module.exports = __webpack_public_path__ + "img/21-CRN.fe2716cd.jpg";